// AI Generated Test
import { Component, OnInit } from '@angular/core';
import { CookieBannerHelperService } from '../../services/helper/helper.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { COOKIE_CATEGORIES } from '@client/ng2/core/constants/cookie-categories.constant';
import { DateTimeService } from '@client/app/services/date-time/date-time.service';
import { DemoHasAccessService } from '@client/app/modules/demodata/services/demo-has-access.service';
import moment from 'moment';
import { ParamService } from '@monsido/ng2/core/param/param.service';
import { DateRangeService } from '@client/app/services/date-range/date-range.service';
import { DEFAULTS } from '@client/ng2/core/constants/defaults.constant';
import { CookieBannerRepoService } from '../../services/cookie-banner-repo.service';
import TIME_ZONE from '@monsido/ng2/core/constants/timeZone.constant.json';
import { StateService } from '@uirouter/core';
import { MessageEncoder } from '@monsido/consent-message-encoder';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'consent-log',
    standalone: false,
    template: `
        <div id="consentLog">
            <div class="alert alert-warning font-size-1-3 font-weight-500 justify-content-center row" *ngIf="isDemo" translate>
                Consent results are sample data for demo purposes
            </div>
            <page-header
                [icon]="['SIDEMENUES', 'DATA_PRIVACY', 'CONSENT_OVERVIEW', 'CONSENT_LOG'] | monIcons"
                [header]="'Consent Log' | translate"
                [subHeader]="subheaderTranslation">
                <page-header-content>
                    <date-picker
                        [hidden]="hideDatepicker"
                        (dateChange)="getPage()"
                        [(date)]="date"
                        [monDateFormat]="dateFormat"
                        [options]="datePickerOptions"
                        class="pull-right">
                    </date-picker>
                </page-header-content>
            </page-header>
            <form (ngSubmit)="submitForm()" class="mb-2" [name]="'search-uuid'">
                <div class="row row-valign-center">
                    <div class="col-40 col-md-20 pr-0">
                        <table-search [model]="uuid"
                                      (modelChange)="clearUUID($event)"
                                      placeholderTxt="Search for UUID"
                                      theme="white">
                        </table-search>
                        <span class="form-text text-muted text-danger" translate *ngIf="emptySubmit">
                            Please enter a full UUID string. Empty or partial strings will not yield any results.
                        </span>
                    </div>
                    <div class="col-8 col-md-auto mr-auto pl-1 pr-0">
                        <button type="submit" class="btn btn-border-radius btn-secondary">
                            <span class="font-size-1-1" translate>
                                Search
                            </span>
                        </button>
                        <span class="fas fa-question-circle inline-block py-1 pl-1 icon-valign-center"
                              tabindex="0"
                              [ngbTooltip]="'UUID can only be searched by entering the full value' | translate"
                              [triggers]="'focus hover'"
                              [placement]="'top'"
                              [container]="'body'">
                        </span>
                    </div>
                </div>
            </form>

            <div class="card panel-monsido-card">
                <div class="card-body">
                    <table-container-pager [page]="page"
                                           [pageSize]="pageSize"
                                           [collection]="consents"
                                           (onPageChange)="onPageChange($event)"
                                           (onPerPageChange)="onPageSizeChange($event)"
                                           [progress]="progress"
                                           class="pages-table-wrapper">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th class="text-left" translate>
                                        IP Address
                                    </th>
                                    <th class="text-left" translate>
                                        UUID
                                    </th>
                                    <th class="text-right col-8" translate>
                                        Location
                                    </th>
                                    <th class="text-right col-8" translate>
                                        Accepted cookies
                                    </th>
                                    <th monTableSort
                                        [monSortBy]="'timestamp'"
                                        [monSortDirection]="currentSort.direction"
                                        [monCurrentlySortedBy]="currentSort.by"
                                        (monOnSorted)="onMonTableSort($event)"
                                        class="text-right col-8"
                                        translate>
                                        Date
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let consent of consents">
                                    <td class="text-left text-v-middle">
                                        <span>{{ consent.anon_ip }}</span>
                                        <span class="label anon-ip-label">
                                            <span class="fas fa-sm fa-asterisk"></span>
                                            <span class="fas fa-sm fa-asterisk"></span>
                                            <span class="fas fa-sm fa-asterisk"></span>
                                            <span class="fas fa-sm fa-asterisk"></span>
                                        </span>
                                    </td>
                                    <td class="text-left text-v-middle">
                                        <span>{{ consent.UserSessionId }}</span>
                                    </td>
                                    <td class="text-right text-v-middle">
                                        <span>{{ consent.country_code }}</span>
                                    </td>
                                    <td class="text-right text-v-middle">
                                        <div *ngIf="consent.consentedCookiesView" [ngClass]="consent.consentedCookiesView.cssClass" class="label label-cookies ml-auto">
                                            <div *ngFor="let text of consent.consentedCookiesView.text" class="label-cookie-content">{{ text }}</div>
                                        </div>
                                    </td>
                                    <td class="text-right text-v-middle">{{ consent.date }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </table-container-pager>
                </div>
            </div>
        </div>
    `,
})
export class ConsentLogComponent extends BaseContainerComponentController implements OnInit {
    subheaderTranslation: string = '';
    consents: any = [];
    uuid: string = '';
    emptySubmit: boolean = false;
    hideDatepicker: boolean = false;
    date: any;
    dateFormat: string = '';
    datePickerOptions: any = {};
    isDemo: boolean = false;
    progress: any;
    loading: boolean = false;

    constructor (
        private cookieBannerHelperService: CookieBannerHelperService,
        private translateService: TranslateService,
        private dateTimeService: DateTimeService,
        private demoHasAccessService: DemoHasAccessService,
        private paramService: ParamService,
        private dateRangeService: DateRangeService,
        private cookieBannerRepoService: CookieBannerRepoService,
        private stateService: StateService,
    ) {
        super({ table: true });
    }

    ngOnInit (): void {
        this.emptySubmit = false;
        this.hideDatepicker = false;
        this.subheaderTranslation = this.translateService.getString('A log of all the consents given by your website visitors');
        this.consents = [];
        this.uuid = '';
        this.currentSort = { by: 'timestamp', direction: 'desc' };
        this.date = this.dateRangeService.setRangeDates({
            todayAsDefaultEnd: true,
        });
        this.dateFormat = DEFAULTS.DATE_FORMAT;
        this.datePickerOptions = { maxDate: this.dateTimeService.toDate(undefined) };
        this.loadLocations();
    }

    submitForm (): void {
        if (!/^([0-9a-z]+-){4}([0-9a-z]+)$/.test(this.uuid)) {
            this.emptySubmit = true;
        } else {
            this.getPage();
        }
    }

    clearUUID (search: any): void {
        this.uuid = search;
        if (!search) {
            this.getPage();
        }
    }

    loadLocations (): void {
        const searchParams = this.stateService.params;
        this.uuid = searchParams.uuid || null;
        const from = searchParams.from;
        const to = searchParams.to;

        if (to) {
            this.date.endDate = moment(to);
        } else {
            this.date.endDate = moment().endOf('day');
        }

        if (from) {
            this.date.startDate = moment(from);
        } else {
            this.date.startDate = moment().subtract(7, 'days').startOf('day');
        }

        this.getPage();
    }

    override getPage = (): void => {
        this.paramService.setParams({
            from: moment(this.date.startDate),
            to: moment(this.date.endDate),
            uuid: this.uuid,
        });

        this.getConsents();
    };

    getConsents (): void {
        this.emptySubmit = false;
        this.loading = true;
        const params: any = {
            page: this.page,
            page_size: this.pageSize,
            sort_dir: this.currentSort.direction,
            sort_by: this.currentSort.by,
        };

        if (this.uuid) {
            params.session_id = this.uuid;
            this.hideDatepicker = true;
        } else {
            params.from = this.date.startDate;
            params.to = this.date.endDate;
            this.hideDatepicker = false;
        }

        this.isDemo = this.demoHasAccessService.isDemoConsentManager();
        if (this.isDemo) {
            this.updateConsents(this.generateData());
        } else {
            this.progress = this.cookieBannerRepoService.getConsents(params)
                .then((consents: any) => {
                    try {
                        this.updateConsents(consents);
                    } catch (e) {
                        this.consents = [];
                    }
                }, () => {})
                .finally(() => {
                    this.loading = false;
                });
        }
    }

    updateConsents (consents: any): void {
        this.consents = consents.map((consent: any) => {
            const content = this.parseContent(consent.tc_string);
            const consentedCookies = content.consents || [];
            return {
                timestamp: consent.timestamp,
                date: this.dateTimeService.format(consent.timestamp, 'll'),
                country_code: this.countryView(consent.country_code),
                anon_ip: this.consentIpView(consent.anon_ip),
                consentedCookies: consentedCookies,
                consentedCookiesView: this.consentedCookiesView(consentedCookies),
                UserSessionId: content.session_id,
            };
        });
        this.consents.total = consents.total;
    }

    parseContent (tcString: string): any {
        return MessageEncoder.tcStringDecode(tcString);
    }

    countryView (countryCode: string): string | null {
        if (!countryCode || typeof countryCode !== 'string') {
            return null;
        }
        const countryObj = TIME_ZONE.countries[countryCode.toUpperCase()];
        if (!countryObj) {
            return null;
        }

        return countryObj.name;
    }

    consentIpView (ip: string): string {
        try {
            const firstColonOccurrence = ip.indexOf(':');
            if (firstColonOccurrence > -1) {
                // is ipv6
                return ip.substring(0, ip.indexOf(':', firstColonOccurrence + 1));
            } else {
                return ip.substring(0, ip.lastIndexOf('.0.0'));
            }
        } catch (e) {
            return ip;
        }
    }

    consentedCookiesView (cookies: any[]): any {
        if (cookies.length === 0) {
            return null;
        }
        const text: string[] = [];
        let cssClass = '';

        if (cookies.length === 1 && cookies[0] === COOKIE_CATEGORIES.essential) {
            text.push(this.translateService.getString(this.cookieBannerHelperService.getCookiePreferenceLabel(cookies[0])));
            cssClass = 'label-danger';
        } else if (cookies.length > 1 && cookies.length < 5) {
            cookies.forEach((cookie: any) => {
                // Don't show essential cookie on the view
                if (cookie !== COOKIE_CATEGORIES.essential) {
                    text.push(this.translateService.getString(this.cookieBannerHelperService.getCookiePreferenceLabel(cookie)));
                }
            });
            cssClass = 'label-warning';
        } else if (cookies.length === 5) {
            text.push(this.translateService.getString('All'));
            cssClass = 'label-success';
        }

        return {
            text: text,
            cssClass: cssClass,
        };
    }

    generateData (): any[] {
        return [
            {
                timestamp: '2021-07-27T08:09:26.000+00:00',
                page_url: 'http://localhost:8000/',
                user_agent:
                    'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/91.0.4472.164 Safari/537.36',
                country_code: 'DK',
                anon_ip: '2a02:aa2:3252:3ad6::',
                tc_string:
                    'CgASCWVzc2VudGlhbBIFYmFzaWMSCW1hcmtldGluZxIJYW5hbHl0aWNzEg9wZXJzb25hbGlzYXRpb24YhZqEhrUvIiRhZGYwNzAwYS03NWM3LTQ5OTktYTVmZi1hNzZhYTgzN2EzNzcqxwEKBGNjcGEKBGdkcHISABgBIAEoAzAAOABAAEoFZW4tVVNSQGh0dHBzOi8vbW9uc2lkby5jb20vZGF0YS1wcm90ZWN0aW9uLWFuZC1wcml2YWN5LXBvbGljeS1zdGF0ZW1lbnRaIWh0dHBzOi8vbW9uc2lkby5jb20vY29va2llLXBvbGljeWAAagsKByNmNTAwNTcSAHIFZW4tVVN6BmNvb2tpZYIBIAgBEhojY29va2llLW92ZXJ2aWV3LWNvbnRhaW5lchgAMgoIARABGAEgASgB',
            },
            {
                timestamp: '2021-07-27T08:09:26.000+00:00',
                page_url: 'http://localhost:8000/',
                user_agent:
                    'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/91.0.4472.164 Safari/537.36',
                country_code: 'DK',
                anon_ip: '87.50.0.0',
                tc_string:
                    'CgASCWVzc2VudGlhbBIFYmFzaWMSCW1hcmtldGluZxIJYW5hbHl0aWNzEg9wZXJzb25hbGlzYXRpb24YhZqEhrUvIiRhZGYwNzAwYS03NWM3LTQ5OTktYTVmZi1hNzZhYTgzN2EzNzcqxwEKBGNjcGEKBGdkcHISABgBIAEoAzAAOABAAEoFZW4tVVNSQGh0dHBzOi8vbW9uc2lkby5jb20vZGF0YS1wcm90ZWN0aW9uLWFuZC1wcml2YWN5LXBvbGljeS1zdGF0ZW1lbnRaIWh0dHBzOi8vbW9uc2lkby5jb20vY29va2llLXBvbGljeWAAagsKByNmNTAwNTcSAHIFZW4tVVN6BmNvb2tpZYIBIAgBEhojY29va2llLW92ZXJ2aWV3LWNvbnRhaW5lchgAMgoIARABGAEgASgB',
            },
            {
                timestamp: '2021-07-27T08:09:15.000+00:00',
                page_url: 'http://localhost:8000/',
                user_agent:
                    'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/91.0.4472.164 Safari/537.36',
                country_code: 'DK',
                anon_ip: '87.50.0.0',
                tc_string:
                    'CgASCWVzc2VudGlhbBIFYmFzaWMSCW1hcmtldGluZxIJYW5hbHl0aWNzEg9wZXJzb25hbGlzYXRpb24YhZqEhrUvIiRhZGYwNzAwYS03NWM3LTQ5OTktYTVmZi1hNzZhYTgzN2EzNzcqxwEKBGNjcGEKBGdkcHISABgBIAEoAzAAOABAAEoFZW4tVVNSQGh0dHBzOi8vbW9uc2lkby5jb20vZGF0YS1wcm90ZWN0aW9uLWFuZC1wcml2YWN5LXBvbGljeS1zdGF0ZW1lbnRaIWh0dHBzOi8vbW9uc2lkby5jb20vY29va2llLXBvbGljeWAAagsKByNmNTAwNTcSAHIFZW4tVVN6BmNvb2tpZYIBIAgBEhojY29va2llLW92ZXJ2aWV3LWNvbnRhaW5lchgAMgoIARABGAEgASgB',
            },
            {
                timestamp: '2021-07-26T15:02:04.000+00:00',
                page_url: 'http://localhost:8000/',
                user_agent:
                    'Mozilla/5.0 (Linux; Android 6.0.1; Moto G (4)) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/91.0.4472.164 Mobile Safari/537.36',
                country_code: 'DK',
                anon_ip: '87.50.0.0',
                tc_string:
                    'CgASCWVzc2VudGlhbBIFYmFzaWMSCW1hcmtldGluZxIJYW5hbHl0aWNzGIzw9Ia1LyIkYWRmMDcwMGEtNzVjNy00OTk5LWE1ZmYtYTc2YWE4MzdhMzc3KscBCgRjY3BhCgRnZHByEgAYASABKAMwADgAQABKBWVuLVVTUkBodHRwczovL21vbnNpZG8uY29tL2RhdGEtcHJvdGVjdGlvbi1hbmQtcHJpdmFjeS1wb2xpY3ktc3RhdGVtZW50WiFodHRwczovL21vbnNpZG8uY29tL2Nvb2tpZS1wb2xpY3lgAGoLCgcjZjUwMDU3EgByBWVuLVVTegZjb29raWWCASAIARIaI2Nvb2tpZS1vdmVydmlldy1jb250YWluZXIYADIKCAEQARgBIAEoAA==',
            },
            {
                timestamp: '2021-07-26T15:00:44.000+00:00',
                page_url: 'http://localhost:8000/',
                user_agent:
                    'Mozilla/5.0 (Linux; Android 8.0.0; Pixel 2 XL Build/OPD1.170816.004) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/91.0.4472.164 Mobile Safari/537.36',
                country_code: 'DK',
                anon_ip: '87.50.0.0',
                tc_string:
                    'CgASCWVzc2VudGlhbBIFYmFzaWMSCW1hcmtldGluZxIJYW5hbHl0aWNzEg9wZXJzb25hbGlzYXRpb24YhZqEhrUvIiRhZGYwNzAwYS03NWM3LTQ5OTktYTVmZi1hNzZhYTgzN2EzNzcqxwEKBGNjcGEKBGdkcHISABgBIAEoAzAAOABAAEoFZW4tVVNSQGh0dHBzOi8vbW9uc2lkby5jb20vZGF0YS1wcm90ZWN0aW9uLWFuZC1wcml2YWN5LXBvbGljeS1zdGF0ZW1lbnRaIWh0dHBzOi8vbW9uc2lkby5jb20vY29va2llLXBvbGljeWAAagsKByNmNTAwNTcSAHIFZW4tVVN6BmNvb2tpZYIBIAgBEhojY29va2llLW92ZXJ2aWV3LWNvbnRhaW5lchgAMgoIARABGAEgASgB',
            },
            {
                timestamp: '2021-07-26T14:45:32.000+00:00',
                page_url: 'http://localhost:8000/',
                user_agent:
                    'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/91.0.4472.164 Safari/537.36',
                country_code: 'DK',
                anon_ip: '87.50.0.0',
                tc_string:
                    'CgASCWVzc2VudGlhbBIFYmFzaWMSD3BlcnNvbmFsaXNhdGlvbhijtPOGtS8iJGFkZjA3MDBhLTc1YzctNDk5OS1hNWZmLWE3NmFhODM3YTM3NyrHAQoEY2NwYQoEZ2RwchIAGAEgASgDMAA4AEAASgVlbi1VU1RAaHR0cHM6Ly9tb25zaWRvLmNvbS9kYXRhLXByb3RlY3Rpb24tYW5kLXByaXZhY3ktcG9saWN5LXN0YXRlbWVudFohaHR0cHM6Ly9tb25zaWRvLmNvbS9jb29raWUtcG9saWN5YABqCwoHI2Y1MDA1NxIAcgVlbi1VU3oGY29va2llggEgCAESGiNjb29raWUtb3ZlcnZpZXctY29udGFpbmVyGAAyCggBEAEYACAAKAE',
            },
            {
                timestamp: '2021-07-26T14:21:57.000+00:00',
                page_url: 'http://localhost:8000/',
                user_agent:
                    'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/92.0.4515.107 Safari/537.36 Edg/92.0.902.55',
                country_code: 'DK',
                anon_ip: '31.3.0.0',
                tc_string:
                    'CgASCWVzc2VudGlhbBIFYmFzaWMSCW1hcmtldGluZxIJYW5hbHl0aWNzEg9wZXJzb25hbGlzYXRpb24YhZqEhrUvIiRhZGYwNzAwYS03NWM3LTQ5OTktYTVmZi1hNzZhYTgzN2EzNzcqxwEKBGNjcGEKBGdkcHISABgBIAEoAzAAOABAAEoFZW4tVVNSQGh0dHBzOi8vbW9uc2lkby5jb20vZGF0YS1wcm90ZWN0aW9uLWFuZC1wcml2YWN5LXBvbGljeS1zdGF0ZW1lbnRaIWh0dHBzOi8vbW9uc2lkby5jb20vY29va2llLXBvbGljeWAAagsKByNmNTAwNTcSAHIFZW4tVVN6BmNvb2tpZYIBIAgBEhojY29va2llLW92ZXJ2aWV3LWNvbnRhaW5lchgAMgoIARABGAEgASgB',
            },
            {
                timestamp: '2021-07-26T14:16:21.000+00:00',
                page_url: 'http://localhost:8000/',
                user_agent:
                    'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/92.0.4515.107 Safari/537.36 Edg/92.0.902.55',
                country_code: 'DK',
                anon_ip: '31.3.0.0',
                tc_string:
                    'CgASCWVzc2VudGlhbBIFYmFzaWMSD3BlcnNvbmFsaXNhdGlvbhijtPOGtS8iJGFkZjA3MDBhLTc1YzctNDk5OS1hNWZmLWE3NmFhODM3YTM3NyrHAQoEY2NwYQoEZ2RwchIAGAEgASgDMAA4AEAASgVlbi1VU1RAaHR0cHM6Ly9tb25zaWRvLmNvbS9kYXRhLXByb3RlY3Rpb24tYW5kLXByaXZhY3ktcG9saWN5LXN0YXRlbWVudFohaHR0cHM6Ly9tb25zaWRvLmNvbS9jb29raWUtcG9saWN5YABqCwoHI2Y1MDA1NxIAcgVlbi1VU3oGY29va2llggEgCAESGiNjb29raWUtb3ZlcnZpZXctY29udGFpbmVyGAAyCggBEAEYACAAKAE',
            },
            {
                timestamp: '2021-07-26T14:16:19.000+00:00',
                page_url: 'http://localhost:8000/',
                user_agent:
                    'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/92.0.4515.107 Safari/537.36 Edg/92.0.902.55',
                country_code: 'DK',
                anon_ip: '31.3.0.0',
                tc_string:
                    'CgASCWVzc2VudGlhbBIFYmFzaWMSCW1hcmtldGluZxIJYW5hbHl0aWNzEg9wZXJzb25hbGlzYXRpb24YhZqEhrUvIiRhZGYwNzAwYS03NWM3LTQ5OTktYTVmZi1hNzZhYTgzN2EzNzcqxwEKBGNjcGEKBGdkcHISABgBIAEoAzAAOABAAEoFZW4tVVNSQGh0dHBzOi8vbW9uc2lkby5jb20vZGF0YS1wcm90ZWN0aW9uLWFuZC1wcml2YWN5LXBvbGljeS1zdGF0ZW1lbnRaIWh0dHBzOi8vbW9uc2lkby5jb20vY29va2llLXBvbGljeWAAagsKByNmNTAwNTcSAHIFZW4tVVN6BmNvb2tpZYIBIAgBEhojY29va2llLW92ZXJ2aWV3LWNvbnRhaW5lchgAMgoIARABGAEgASgB',
            },
            {
                timestamp: '2021-07-26T14:16:02.000+00:00',
                page_url: 'http://localhost:8000/',
                user_agent:
                    'Mozilla/5.0 (iPhone; CPU iPhone OS 10_3_1 like Mac OS X) AppleWebKit/603.1.30 (KHTML, like Gecko) Version/10.0 Mobile/14E304 Safari/602.1 Edg/92.0.4515.107',
                country_code: 'DK',
                anon_ip: '31.3.0.0',
                tc_string:
                    'CgASCWVzc2VudGlhbBIFYmFzaWMSCW1hcmtldGluZxIJYW5hbHl0aWNzGIzw9Ia1LyIkYWRmMDcwMGEtNzVjNy00OTk5LWE1ZmYtYTc2YWE4MzdhMzc3KscBCgRjY3BhCgRnZHByEgAYASABKAMwADgAQABKBWVuLVVTUkBodHRwczovL21vbnNpZG8uY29tL2RhdGEtcHJvdGVjdGlvbi1hbmQtcHJpdmFjeS1wb2xpY3ktc3RhdGVtZW50WiFodHRwczovL21vbnNpZG8uY29tL2Nvb2tpZS1wb2xpY3lgAGoLCgcjZjUwMDU3EgByBWVuLVVTegZjb29raWWCASAIARIaI2Nvb2tpZS1vdmVydmlldy1jb250YWluZXIYADIKCAEQARgBIAEoAA==',
            },
            {
                timestamp: '2021-07-26T14:15:49.000+00:00',
                page_url: 'http://localhost:8000/',
                user_agent:
                    'Mozilla/5.0 (iPhone; CPU iPhone OS 10_3_1 like Mac OS X) AppleWebKit/603.1.30 (KHTML, like Gecko) Version/10.0 Mobile/14E304 Safari/602.1 Edg/92.0.4515.107',
                country_code: 'DK',
                anon_ip: '31.3.0.0',
                tc_string:
                    'CgASCWVzc2VudGlhbBIFYmFzaWMSD3BlcnNvbmFsaXNhdGlvbhijtPOGtS8iJGFkZjA3MDBhLTc1YzctNDk5OS1hNWZmLWE3NmFhODM3YTM3NyrHAQoEY2NwYQoEZ2RwchIAGAEgASgDMAA4AEAASgVlbi1VU1RAaHR0cHM6Ly9tb25zaWRvLmNvbS9kYXRhLXByb3RlY3Rpb24tYW5kLXByaXZhY3ktcG9saWN5LXN0YXRlbWVudFohaHR0cHM6Ly9tb25zaWRvLmNvbS9jb29raWUtcG9saWN5YABqCwoHI2Y1MDA1NxIAcgVlbi1VU3oGY29va2llggEgCAESGiNjb29raWUtb3ZlcnZpZXctY29udGFpbmVyGAAyCggBEAEYACAAKAE',
            },
        ];
    }
}
